import { isDateValid } from "../components/BSL_DatePicker";
import { isPriceRiseActive } from "./PriceRise";

const check_site_address = ({ job }) => {
    if (job?.Customer?.Address?.FormattedAddress === "" && job?.SiteParameters?.Address?.FormattedAddress === "") {
        return "Site Address Required";
    }
    return "";
};

const check_delivery_date = (jobDate, config) => {
    const disableForwardDays = 14; // Minimum delivery lead time
    const enableWeekends = false; // Weekends not allowed

    if (!isPriceRiseActive(config)) {
        return "";
    }

    if (!jobDate) {
        return "No delivery date specified";
    }

    const valid = isDateValid(jobDate, { disableForwardDays, enableWeekends });
    return valid ? "" : "Invalid Delivery Date";
};

export const printing_rule_failed = ({ job, config }) => {
    if (!job && !config) return ""; // Not loaded
    let print_failed_reason = "";

    print_failed_reason = check_site_address({ job });
    if (print_failed_reason) return print_failed_reason;

    const jobDate = job?.QuoteParameters?.DeliveryDate;
    print_failed_reason = check_delivery_date(jobDate, config);

    return print_failed_reason;
};
